<form class="comment-input-container" #commentTextInput [formGroup]="commentInputForm">
	<div class="comment-input-header">
		<button class="secondary-fab" [matMenuTriggerFor]="addEntityMenu" mat-mini-fab>
			<mat-icon svgIcon="add"></mat-icon>
		</button>

		<div class="vertical-divider"></div>
		<div>
			<button mat-icon-button class="at-icon" (click)="atBtnClicked()">&#64;</button>
		</div>
	</div>
	<quill-editor
		format="html"
		formControlName="textArea"
		class="ql-mention-list-container nice-scroll visible-scroll colored-scroll-track"
		[modules]="modules"
		[placeholder]="
			(sendAsEmail() ? 'leave_reply_here' : 'leave_comment_here') | translate
		"
		(keyup)="trackCommentInput($event)"
	>
	</quill-editor>
	<div [ngClass]="request() ? 'below-comment-input' : 'send-button'">
		@if (request()) {
			<div class="comment-type">
				<mat-button-toggle-group
					#tooltip="matTooltip"
					class="toggle-reply-group"
					name="replyType"
					[matTooltip]="'set_requester_to_enable_reply' | translate"
					[matTooltipDisabled]="request().requestees[0]"
				>
					<mat-button-toggle
						class="toggle-reply-button"
						[checked]="!sendAsEmail()"
						(click)="sendAsEmail.set(false)"
					>
						<mat-icon svgIcon="chat"></mat-icon>
						{{ 'comment' | translate }}</mat-button-toggle
					>
					<mat-button-toggle
						class="toggle-reply-button"
						[disabled]="!request().requestees[0]"
						(click)="sendAsEmail.set(true)"
					>
						<mat-icon svgIcon="mail"></mat-icon>
						{{ 'reply' | translate }}
					</mat-button-toggle>
				</mat-button-toggle-group>

				@if (sendAsEmail()) {
					<div class="vertical-divider"></div>

					<p>
						{{ 'to' | translate }}:
						{{ request().requestees[0].email }}
					</p>
				}
			</div>
		}
		<div class="send-button">
			<button
				[matTooltip]="
					'ctrl_enter_to_submit'
						| translate: { type: (sendAsEmail() ? 'reply' : 'comment') | translate }
				"
				mat-icon-button
				class="primary-icon-button"
				[disabled]="!formControl.valid"
				(click)="submitNewComment()"
			>
				<mat-icon svgIcon="envelop"></mat-icon>
			</button>
		</div>
	</div>
</form>

<mat-menu #addEntityMenu="matMenu" class="new-entity-menu">
	<div>
		<button mat-menu-item (click)="newEntity('newWorkOrder')">
			<mat-icon svgIcon="workorder"></mat-icon>
			{{ 'add' | translate }} {{ 'new_work_order' | translate | lowercase }}
		</button>
		<div class="divider"></div>
		<button mat-menu-item (click)="newEntity('newIncident')">
			{{ 'add' | translate }} {{ 'new_incident' | translate | lowercase }}
			<mat-icon svgIcon="incident"></mat-icon>
		</button>
		<div class="divider"></div>
		<button mat-menu-item (click)="newEntity('newAsset')">
			{{ 'add_new_asset' | translate }}
			<mat-icon svgIcon="asset"></mat-icon>
		</button>

		<button mat-menu-item (click)="newEntity('existingEntities', 'ASSETS')">
			{{ 'add' | translate }} {{ 'existing_asset' | translate | lowercase }}
			<mat-icon svgIcon="digital-twin"></mat-icon>
		</button>
		<div class="divider"></div>
		<button mat-menu-item (click)="newEntity('files')">
			{{ 'add' | translate }} {{ 'new_file' | translate | lowercase }}
			<mat-icon svgIcon="file"></mat-icon>
		</button>

		<button mat-menu-item (click)="newEntity('existingEntities', 'FILES')">
			{{ 'add' | translate }} {{ 'existing_file' | translate | lowercase }}
			<mat-icon svgIcon="add-file"></mat-icon>
		</button>
	</div>
</mat-menu>
